<template>
    <b-button
        @click="() => { modalState = true }"
        size="sm"
        :disabled="buttonDisabled"
        :variant="(httpRequestInProgress) ? 'success': 'primary'"
    ><!-- button -->
        <span v-if="httpRequestInProgress">
            <b-spinner
                type="grow"
                label="Loading..."
                small
            />
            </span>
        <span v-else>{{buttonLabel}}</span>
        <b-modal
            v-model="modalState"
            id="modal-unfreeze-order"
            title="Bestellung Freigeben"
            @ok="submit()"
            cancel-title="abbrechen"
            size="md"
        ><!-- modal -->
            {{messagePrompt}}
        </b-modal>
    </b-button>
</template>
<script>
    export default {
        props: ['customerOrder', 'messagePrompt', 'disabled', 'buttonLabel', 'request', 'mutate' ]
        , data() {
            return {
                modalState: false,
                httpRequestInProgress: false
            }
        }
        , computed: {
           buttonDisabled: function() { return this.httpRequestInProgress || this.disabled }
        }
        , methods: {
            submit() {
                this.httpRequestInProgress = true;
                // guarantees a minium delay of 750ms or longer, if request takes longer. The animation looks very consistent thereby.
                //NICE very cool trick, gotta remember this one
                let axiosRequest = null;
                switch(this.request.type)
                {
                    case "POST":
                        if(this.request.payload) {
                            axiosRequest = axios.post(this.request.url, this.request.payload);
                        }else{
                            axiosRequest = axios.post(this.request.url);
                        }
                    break;
                    case "GET":
                        if(this.request.params) {
                            axiosRequest = axios.get(this.request.url, this.request.params);
                        }else{
                            axiosRequest = axios.get(this.request.url);
                        }
                    break;
                    default: alert("Fehler: bitte melden. FehlerNummer: 234098 (bitte aufschreiben)."); break;
               }
                
                Promise.all([
                    axiosRequest,
                    new Promise(r => setTimeout(r, 750))
                ]).then( response => {
                    this.httpRequestInProgress = false;
                    if(this.mutate)
                    {
                        if(0 == this.mutate.length)
                        {
                            //const dump = this.mutate.bind(this); // for some reason, this still doesn't work.
                            //dump();
                        }
                        else if(1 == this.mutate.length)
                        {
                            // let dump = this.mutate.bind(this)(response);
                            // console.log("this bound", dump);
                            // dump();
                        }
                        else
                        {
                            alert("zu viele mutate parameter. Bitte melden.");
                        }
                    }
                }).catch( error => {
                    alert("konnte Status nicht ändern");
                    console.error(error);
                });
            }
        }
    }
</script>
